import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyResultSetMessage from 'components/@common/EmptyResultSetMessage';
import Skeleton from 'components/@common/Skeleton';

const EmptyReportMessage: React.FC = () => {
  const { t } = useTranslation('Reports');

  return <EmptyResultSetMessage variant="custom" message={t('emptyMessage')} messageVariant="h6" />;
};

export interface MaybeRenderReportElementProps {
  loading: boolean;
  loadingHeight?: number;
  shouldRender: boolean;
  width?: string;
}
/**
 *
 * contains skeleton for loading
 */
const MaybeShowErrorMessageWithLoading: React.FC<MaybeRenderReportElementProps> = ({
  loading,
  loadingHeight = 250,
  width,
  shouldRender,
  children
}) => {
  if (loading) return <Skeleton height={loadingHeight} width={width} />;

  return !shouldRender ? <EmptyReportMessage /> : (children as React.ReactElement);
};

export default MaybeShowErrorMessageWithLoading;
